'use client';

import { useSyncExternalStore } from 'react';
import { formatLocal, formatPacific } from '@/lib/time/format';

const noopSubscribe = () => () => {};

/**
 * A timestamp in the viewer's own time zone, e.g. "11/3/2026, 9:02:15 AM CST".
 * The server (and the first hydration pass) renders Pacific time, so the
 * markup matches; React then swaps in the browser-local value.
 */
export function LocalTime({ iso }: { iso: string }) {
  const text = useSyncExternalStore(
    noopSubscribe,
    () => formatLocal(iso),
    () => formatPacific(iso),
  );
  return <time dateTime={iso}>{text}</time>;
}
